import { Fragment, useRef, useState } from 'react';
import { SignatureTemplate } from './SignatureTemplate';
import { Input, useToast } from '@teamsnap/snap-ui';
import { Button } from '@teamsnap/teamsnap-ui';
import { useUserSelector } from 'state/user/userSlice';
import { SignatureTemplateParams } from './TemplateParams';
import { TS1SignatureTemplate } from './TS1SignatureTemplate';

export function EmailSignatureGenerator() {
  const { toast } = useToast();

  const user = useUserSelector();

  const componentRef = useRef<HTMLDivElement>(null);
  const [type, setType] = useState<'tsc' | 'ts1'>('tsc');

  const [params, setParams] = useState<SignatureTemplateParams>({
    disablePhoneNumber: false,
    email: user!.email,
    name: `${user!.firstName} ${user!.lastName}`,
    phone: '',
    title: '',
  });

  const copySignature = () => {
    if (!componentRef.current) return;

    const missingProperties = [];
    if (!params.name) {
      missingProperties.push('name');
    }

    if (!params.title) {
      missingProperties.push('title');
    }

    if (!params.phone && !params.disablePhoneNumber) {
      missingProperties.push('phone (or disable)');
    }

    if (!params.email) {
      missingProperties.push('email');
    }

    if (missingProperties.length) {
      toast({ variant: 'negative', title: `Please populate your ${missingProperties.join(',')}` });
      return;
    }
    const content = componentRef.current.innerHTML;
    const blob = new Blob([content], { type: 'text/html' });
    const clipboardItem = new window.ClipboardItem({ 'text/html': blob, 'text/plain': componentRef.current.innerText });
    navigator.clipboard.write([clipboardItem]);

    toast({ variant: 'success', title: 'Signature copied to clipboard' });
  };

  return (
    <div style={{ marginTop: '20px' }} className="sui-flex sui-justify-between sui-w-dvw">
      <div style={{ margin: '0 10px' }} className="sui-flex-1 w-full">
        <div style={{ marginBottom: '20px' }}>
          Style Type
          <div>
            <select
              className="sui-rounded sui-border-gray-4 sui-border sui-px-1 sui-py-2 sui-w-full sui-text-desktop-5"
              value={type}
              onChange={(o) => setType(o.target.value as 'tsc' | 'ts1')}
            >
              <option value="tsc">TeamSnap</option>
              <option value="ts1">TeamSnap ONE</option>
            </select>
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          Your Name
          <Input
            name="name"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setParams((s) => ({ ...s, name: e.target.value }));
            }}
            placeholder="Your name"
            allowClear
            value={params.name}
            type="text"
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          Your Title
          <Input
            name="title"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setParams((s) => ({ ...s, title: e.target.value }));
            }}
            placeholder="Your title"
            allowClear
            value={params.title}
            type="text"
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          Your Email
          <Input
            name="email"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setParams((s) => ({ ...s, email: e.target.value }));
            }}
            placeholder="Your email"
            allowClear
            value={params.email}
            type="text"
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          Your Phone Number
          <Input
            name="phone-number"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setParams((s) => ({ ...s, phone: e.target.value }));
            }}
            placeholder="Phone Number"
            allowClear
            value={params.phone}
            type="text"
          />
        </div>
        <div>
          <input
            name="disable-phone-number"
            type="checkbox"
            checked={params.disablePhoneNumber} // Bind the 'checked' attribute to the 'isChecked' state
            onChange={() => setParams((s) => ({ ...s, disablePhoneNumber: !s.disablePhoneNumber }))} // Call 'handleChange' when the checkbox state changes
          />{' '}
          Disable Phone Number
        </div>
        <Button style={{ width: '100%' }} onClick={copySignature}>
          Copy Signature
        </Button>
      </div>

      <div style={{ margin: '0 10px' }} className="sui-flex-1 w-full">
        <div
          style={{
            border: '1px solid black',
            borderRadius: '1rem',
            padding: '12px',
            boxShadow: '2px 2px 20px #1c1c1c',
          }}
          className="sui-bg-white sui-p-12 sui-rounded-lg sui-shadow-2xl sui-shadow-slate-600"
          ref={componentRef}
        >
          {type === 'tsc' ? <SignatureTemplate params={params} /> : <TS1SignatureTemplate params={params} />}
        </div>
      </div>
    </div>
  );
}
